import { render, staticRenderFns } from "./SiglesourceNew.vue?vue&type=template&id=f4e3f59e&scoped=true&"
import script from "./SiglesourceNew.vue?vue&type=script&lang=js&"
export * from "./SiglesourceNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e3f59e",
  null
  
)

export default component.exports